import axios from "axios";
import * as actionType from "../../../constant/actionType";

/*** CreateComplianceChecklistReport Action ***/
export const CreateComplianceChecklistReportStart = () => {
    return {
        error: null,
        loader: true,
        isAuthenticated: true,
        type: actionType.CreateComplianceChecklistReport_START,
    };
};
export const CreateComplianceChecklistReportSuccess = (response) => {
    return {
        error: false,
        loader: false,
        isAuthenticated: response.status === 401 ? false : true,
        type: actionType.CreateComplianceChecklistReport_SUCCESS,
    };
};
export const CreateComplianceChecklistReportFail = (error) => {
    return {
        error: error,
        loader: false,
        isAuthenticated: error.status === 401 ? false : true,
        type: actionType.CreateComplianceChecklistReport_FAIL,
    };
};

export const CreateComplianceChecklistReport = ({
    filterpage,
    filterlimit,
    filtersort,
    filterorder,
    client_org_ids,
    date_range,
    cheklistIds,
    recipientType,
    publishDate,
    renewalDate
}) => {
    return (dispatch) => {

        dispatch(CreateComplianceChecklistReportStart());
        const config = {
            method: "get",
            url: `${actionType.environment_url}/api/admin/GenerateComplianceChecklistReport`,
            headers: {
                Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
            },
            params: {
                limit: filterlimit,
                page: filterpage,
                sort: filtersort,
                order: filterorder,
                client_org_ids: client_org_ids? JSON.stringify(client_org_ids) :[],
                date_range: date_range,
                checklist_ids:cheklistIds ? JSON.stringify(cheklistIds):[],
                recipient_type: recipientType,
                joined_date_range: publishDate,
                renewal_date_range: renewalDate
            },
        };

        return axios(config)
            .then(function (response) {
                dispatch(CreateComplianceChecklistReportSuccess(response.data));
                return response.data;
            })
            .catch(function (error) {
                dispatch(
                    CreateComplianceChecklistReportFail("Something went wrong, Please try again.")
                );
                return error;
            });
    };
};